import { STORAGE_GET_SIGNED_URL_ENDPOINT } from '@/constants/endpoints';
import axios from 'axios';

export const getSignedUrl = async (creativeId?: number) => {
  const { data } = await axios.get<{ signedUrl: string; filePath: string }>(STORAGE_GET_SIGNED_URL_ENDPOINT, {
    params: {
      action: 'write',
      creativeId,
    },
  });

  return data;
};
